import { AuthService } from '../../service/auth.service';
import { Component, OnInit,ViewContainerRef } from '@angular/core';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {AngularFirestore,AngularFirestoreCollection} from '@angular/fire/firestore';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  image: File;
  contactForm:FormGroup;
  contact_image:any ;
contact_image_url:any ='';
  FOLDER: any = 'contact/';
  loading: any = false;
   edit: any = false;
  id: any;
  error: any = '';
  constructor(private form:FormBuilder,private router:Router ,private afs:AngularFirestore,private auth: AuthService,
    public toastr: ToastsManager,vcr: ViewContainerRef) {
      this.toastr.setRootViewContainerRef(vcr);
     }

     ngOnInit() {
      this.contactForm = this.form.group({
        content: ['', [Validators.required]],
        upload_Image: ['', []]
      });
      this.checkdata();
    }
    async checkdata() {
      try {
        const contactdata = await this.afs.collection('/Contact').valueChanges();
        contactdata.subscribe(contactdata => {
          console.log(contactdata);
  
          if (contactdata.length >= 1) {
            this.contactForm.get('content').setValue(contactdata[0]['heading']);
            this.contact_image_url = contactdata[0]['imageurl'];
            this.edit = true;
            this.id = contactdata[0]['id'];
          }
        });
      } catch (error) {
        this.error = 'Somthing went wrong please try later';
        this.toastr.error('Somthing went wrong please try later', 'Oops!');
        console.log(error);
      }
    }
    changeListner2(event) {
      this.image = <File>event.target.files[0];
    }

    async addcontact(value, valid) {
      this.error = '';
      if (valid || this.edit) {
        this.loading = true;
        try {
          let uploadedimage;
          if (this.edit) {
            if (this.image) {
              uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);
              await this.afs.doc('Contact/' + this.id).update({ heading: value.content, imageurl: uploadedimage['Location'] });
            } else {
              await this.afs.doc('Contact/' + this.id).update({ heading: value.content });
            }
          } else {
            if (!this.image) {
              this.error = 'Image is required';
              this.toastr.error('Image is required!', 'Oops!');
            }
            uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);
            const addcontact = await this.afs.collection('Contact')
              .add({ heading: value.content, imageurl: uploadedimage['Location'], type: 'mobile' });
            const id = addcontact.id;
            await this.afs.doc(`/Contact/${id}`).update({ id: id });
          }
          this.loading = false;
          this.toastr.success('Contact Information Updated!', 'Success!');
  
        } catch (error) {
          this.loading = false;
          this.toastr.error('Somthing went wrong please try later!', 'Oops!');
          console.log(error);
        }
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/extras/contact/contact.component.ts